import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const chassisLaneRateTypesAdapter = getAdapter({ idFieldName: 'value' });

const chassisLaneRateTypesSlice = createSlice({
  name: 'chassisLaneRateTypes',
  initialState: chassisLaneRateTypesAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setChassisLaneRateTypes: (state, { payload: { chassisLaneRateTypes, source } }) => {
      chassisLaneRateTypesAdapter.setAll(state, chassisLaneRateTypes);
      state.source = source;
    }
  }
});

const selectors = chassisLaneRateTypesAdapter.getSelectors(({ chassisLaneRateTypes }) => chassisLaneRateTypes);

export const getChassisLaneRateTypes = state => selectors.selectAll(state);

export const { setChassisLaneRateTypes } = chassisLaneRateTypesSlice.actions;

export default chassisLaneRateTypesSlice.reducer;
